import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';
import { AuthenticatedUserProvider } from 'src/contexts/AuthenticatedUserContext';
import { ConfigProvider } from 'src/contexts/ConfigContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import RouteLogic from 'src/components/partner-portal/RouteLogic';
import { getAuthenticatedSession } from 'src/api/authentication';
import { identifyActor } from '@repo/shared/analytics';
import { getConfig } from 'src/api/config';

export const Route = createFileRoute('/partner_')({
	component: RouteComponent,
	staleTime: 1000 * 60 * 5,
	loader: async () => {
		const authenticatedSession = await getAuthenticatedSession();
		if (!authenticatedSession.user) {
			throw redirect({
				to: '/authentication/login',
				search: {
					redirect: location.href,
				},
			});
		}

		const config = await getConfig();
		if (!config?.featureFlags?.USES_PARTNER_PORTAL) {
			throw redirect({
				to: '/403',
				search: {
					message: 'Partner portal is not enabled',
				},
			});
		}

		return { authenticatedSession };
	},
});

const queryClient = new QueryClient();

function RouteComponent() {
	const { authenticatedSession } = Route.useLoaderData();

	useEffect(() => {
		identifyActor(authenticatedSession?.user);
	}, [authenticatedSession?.user?.id]);

	return (
		<QueryClientProvider client={queryClient}>
			<AuthenticatedUserProvider authenticatedSession={authenticatedSession}>
				<ConfigProvider>
					<RouteLogic />
					<Outlet />
				</ConfigProvider>
			</AuthenticatedUserProvider>
		</QueryClientProvider>
	);
}
